module.exports = __webpack_public_path__ + "img/icon-gift-card-gray.8a5d39d2.svg";